import { PlusIcon } from 'lucide-react';
import styled from '@emotion/styled';

import pom from '@/utils/pom';
import { applyDataTestId } from '@/utils/testUtils';

interface Props {
  readonly merchantColor: string;
}

const StyledAddIcon = styled.div<Props>`
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  background-color: white;
  border-radius: 0.5rem;
  height: 3rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: ${props => props.merchantColor};
  border: 0.063rem solid ${props => props.merchantColor};

  &:hover {
    background-color: ${props => props.merchantColor};
    border: none;
    color: white;
  }
`;

const ReorderCardContent = ({ merchantColor }: Props) => (
  <StyledAddIcon merchantColor={merchantColor} data-testid={applyDataTestId(pom.orders.reorderPlusIcon)}>
    <PlusIcon height={20} width={20} />
  </StyledAddIcon>
);

export default ReorderCardContent;
